import React from 'react';
import { MailIcon } from 'lucide-react';
import { product } from '../data/content';
export function Contact() {
  return <section className="w-full bg-sand py-14" aria-labelledby="contact-heading" data-id="element-51" data-mp="357dnwl8s06vl">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-52" data-mp="315s4eh1qkucf">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-53" data-mp="318ejd1qyic4o">
          Contact us
        </p>
        <h2 id="contact-heading" className="mt-4 font-display text-2xl font-semibold text-espresso sm:text-3xl" data-id="element-54" data-mp="3sy9an3ydkbvz">
          Questions before you buy?
        </h2>
        <p className="mx-auto mt-4 max-w-prose font-sans text-base leading-relaxed text-cocoa" data-id="element-55" data-mp="3k560b4j10f5k">
          Write to us and we&rsquo;ll get back to you. We answer every message about
          access, content and refunds.
        </p>
        <a href={`mailto:${product.email}`} className="mt-6 inline-flex items-center gap-2 font-sans text-base font-semibold text-espresso underline decoration-gold decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-56" data-mp="ghe2ougdbsni">
          <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-57" data-mp="3b42ji6vnmcrs" />
          {product.email}
        </a>
      </div>
    </section>;
}